import React, { useState } from 'react';
import { Card, Form, Input, Button, message, Space, Alert, Divider } from 'antd';
import { AuthService } from '../../services/authService';
import { buildAPIURL } from '../../config/apiConfig';

const LoginTest: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [loginData, setLoginData] = useState<any>(null);

  const handleLogin = async (values: { username: string; password: string }) => {
    setLoading(true);
    try {
      console.log('🔄 Attempting login with:', values.username);
      
      const result = await AuthService.login({
        username: values.username,
        password: values.password
      });

      console.log('📋 Login result:', result);
      setLoginData(result);

      if (result.success) {
        message.success('Đăng nhập thành công!');
        
        // Log what's stored
        console.log('💾 Stored token:', localStorage.getItem('quanly_truonghoc_token'));
        console.log('💾 Stored user:', localStorage.getItem('userInfo'));
        
        // Check authentication status
        const isAuth = AuthService.isAuthenticated();
        console.log('✅ Is authenticated:', isAuth);
        
        // Test API call
        setTimeout(async () => {
          try {
            const response = await fetch(buildAPIURL('/permissions/modules'), {
              headers: {
                'Authorization': `Bearer ${localStorage.getItem('quanly_truonghoc_token')}`,
                'Content-Type': 'application/json'
              }
            });
            console.log('🧪 API test status:', response.status);
            const data = await response.json();
            console.log('🧪 API test data:', data);
          } catch (error) {
            console.error('🧪 API test error:', error);
          }
        }, 1000);
        
      } else {
        message.error(result.message || 'Đăng nhập thất bại');
      }
    } catch (error) {
      console.error('❌ Login error:', error);
      message.error('Lỗi kết nối');
    } finally {
      setLoading(false);
    }
  };

  const handleClearAll = () => {
    localStorage.clear();
    sessionStorage.clear();
    message.info('Đã xóa tất cả storage');
    setLoginData(null);
  };

  const checkCurrentAuth = () => {
    const token = localStorage.getItem('quanly_truonghoc_token');
    const userInfo = localStorage.getItem('userInfo');
    const isAuth = AuthService.isAuthenticated();
    
    console.log('Current auth status:');
    console.log('- Token:', token?.substring(0, 50) + '...');
    console.log('- UserInfo:', userInfo);
    console.log('- IsAuthenticated:', isAuth);
    
    message.info('Check console for auth details');
  };

  return (
    <div style={{ padding: 24 }}>
      <Card title="🧪 Login Test & Debug">
        <Space direction="vertical" style={{ width: '100%' }}>
          
          {/* Current Auth Status */}
          <Alert
            message="Current Authentication Status"
            description={
              <div>
                <div>Authenticated: {AuthService.isAuthenticated() ? '✅ YES' : '❌ NO'}</div>
                <div>Token exists: {localStorage.getItem('quanly_truonghoc_token') ? '✅ YES' : '❌ NO'}</div>
                <div>User info exists: {localStorage.getItem('userInfo') ? '✅ YES' : '❌ NO'}</div>
              </div>
            }
            type={AuthService.isAuthenticated() ? 'success' : 'warning'}
            showIcon
          />

          <Divider />

          {/* Login Form */}
          <Form
            name="loginTest"
            onFinish={handleLogin}
            layout="vertical"
            style={{ maxWidth: 400 }}
          >
            <Form.Item
              label="Username"
              name="username"
              rules={[{ required: true, message: 'Please input username!' }]}
            >
              <Input placeholder="admin" />
            </Form.Item>

            <Form.Item
              label="Password"
              name="password"
              rules={[{ required: true, message: 'Please input password!' }]}
            >
              <Input.Password placeholder="password" />
            </Form.Item>

            <Form.Item>
              <Space>
                <Button type="primary" htmlType="submit" loading={loading}>
                  Test Login
                </Button>
                <Button onClick={checkCurrentAuth}>
                  Check Auth Status
                </Button>
                <Button danger onClick={handleClearAll}>
                  Clear All Storage
                </Button>
              </Space>
            </Form.Item>
          </Form>

          {/* Login Result */}
          {loginData && (
            <div>
              <Divider />
              <h4>Login Result:</h4>
              <pre style={{ 
                background: '#f5f5f5', 
                padding: 16, 
                borderRadius: 4,
                fontSize: '12px',
                overflow: 'auto'
              }}>
                {JSON.stringify(loginData, null, 2)}
              </pre>
            </div>
          )}

          <Divider />

          {/* Instructions */}
          <Alert
            message="Debug Instructions"
            description={
              <ol style={{ paddingLeft: 20, margin: 0 }}>
                <li>Try login with common admin credentials: admin/admin123, admin/password</li>
                <li>Check console logs for detailed authentication flow</li>
                <li>If login succeeds but still shows "not authenticated", there may be token issues</li>
                <li>Clear storage if you get JWT malformed errors</li>
                <li>Make sure you're using TypeScript backend (localhost:3001)</li>
              </ol>
            }
            type="info"
            showIcon
          />

        </Space>
      </Card>
    </div>
  );
};

export default LoginTest; 